import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { ProductCardPriceInfo } from "../../../../utils/AppUtils";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../../utils/SvgComps";

function CoachingServiceRequestForm({
  setSelectedPreferredSlot,
  errorMsg,
  setRemarks,
  redirectTo,
  priceInfo,
  checkoutLoader,
  preferredSlotData,
  selectedPreferredSlot,
  selectedPreferredDate,
  setSelectedPreferredDate,
  dateError,
  remarksError,
  serviceSlots,
  selectedServiceSlot,
  setSelectedServiceSlot,
}) {
  const { t } = useTranslation();
  const today = new Date();
const yyyy = today.getFullYear();
const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
const dd = String(today.getDate()).padStart(2, '0');

const minDate = `${yyyy}-${mm}-${dd}`;



  return (
    <div className="container-slot w-100 mt-3">
      <div class="sep"></div>
      <div className="pb-3 d-flex justify-content-between">
        <div className="d-flex align-items-center gap-4">
          <div className="mentor-title mb-0">{t("Request your slot")}</div>
        </div>
        {serviceSlots?.length > 1 && (
          <div className="ms-auto">
            <select
              className="form-select input_searchfield ps-3 p-2 pe-5 rounded-pill"
              onChange={(ev) => setSelectedServiceSlot(ev.target.value)}
              value={selectedServiceSlot}
            >
              {serviceSlots.map((ex, index) => {
                return (
                  <option
                    value={ex?.price_id}
                    selected={
                      selectedServiceSlot === ex?.price_id ? true : false
                    }
                    key={index}
                  >
                    {ex?.slot_type}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </div>
      <div className="slotparent">
        <div className="row">
          <div className="col">
            <div className="input-text position-relative disable_field">
              <label htmlFor="manager" className="input__label">
                {t("Preferred Date")}
                {"*"}
              </label>
              <input
                className=" input_searchfield"
                type="date"
                id="dateField"
                name="dateField"
                min={minDate}
                onChange={(e) => setSelectedPreferredDate(e.target.value)}
                value={selectedPreferredDate}
              />
            </div>
            {dateError && <p className="error-msg">{dateError}</p>}
          </div>
          <div className="col">
            <div className="input-text position-relative disable_field">
              <label htmlFor="manager" className="input__label">
                {t("Preferred Slot")}
                {"*"}
              </label>
              <select
                className="form-select input_searchfield"
                id="category"
                aria-label="Default select example"
                onChange={(event) =>
                  setSelectedPreferredSlot(event.target.value)
                }
                required
              >
                <option value="">Select preferred slot</option>
                {preferredSlotData?.map((slot, index) => {
                  return (
                    <option
                      value={slot.label}
                      selected={slot?.label === selectedPreferredSlot}
                      key={index}
                    >
                      {slot.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {errorMsg && <p className="error-msg">{errorMsg}</p>}
          </div>

          <div className="input-text position-relative disable_field">
            <label htmlFor="manager" className="input__label">
              {t("Additional Remarks")}
              {"*"}
            </label>
            <textarea
              type="text"
              rows={3}
              placeholder="Please add message"
              className="input__field"
              onChange={(e) => setRemarks(e.target.value)}
              required
            />
            {remarksError && <p className="error-msg">{remarksError}</p>}
          </div>
        </div>
      </div>
      <div id="checkout-button"></div>
      <div className="sep"></div>
      <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
        <div className="price-sec-xl">
          {!_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : ""}
        </div>
        <div className="d-flex gap-3">
          <FormButtonComponent
            isPrimary={true}
            leftIcon={""}
            rightIcon={<RightArrowIcon />}
            isDisabled={false}
            btnName={t("Proceed to Checkout")}
            btnAction={() => redirectTo()}
            showLoader={checkoutLoader}
            isPaymentButton={true}
          />
        </div>
      </div>
    </div>
  );
}

export default CoachingServiceRequestForm;
